if (document.getElementById('page-reservations')) {
    import('./main-reservations.js')
}

if (document.querySelector('#page-accounting')) {
    import('./main-accounting.js')
}

if (document.querySelector('#page-voucher-admin')) {
    import('./main-voucher-admin.js')
}

if (document.querySelector('#page-pricemodels')) {
    import('./main-pricemodels.js')
}

if (document.querySelector('#page-invoices')) {
    import('./main-invoices.js')
}

if (document.querySelector('#order-flow')) {
    import('./order-flow/index')
}

if (document.querySelector('#page-hotel')) {
    import('./main-hotel.js')
}
